export default "__VITE_ASSET__BtawxRUo__"